export default {
  PATH: ['external_vehicles_batch'],
};
